import type React from 'react';

import { CircularLoader } from '../../../../../components/CircularLoader';

import { StyledLoadingContainer } from './styles';

export const LoadingState: React.FC = () => {
  return (
    <StyledLoadingContainer>
      <CircularLoader />
    </StyledLoadingContainer>
  );
};
